import React, { Component } from "react";
import { Link } from "react-router-dom";
import { logout } from "../../services/loginClient";

export default class Unathorized extends Component {
  logout() {
    logout();
    window.location.href = "/api/logout";
  }

    render() {
    return (
      <div>
        <div>
          <h1>No Autorizado</h1>
          <Link
            to="#"
            onClick={() => {
              this.logout();
            }}
          >
           Desconectar
          </Link>
        </div>
      </div>
    );
  }
}
